
<el-container>
  <main-menu></main-menu>
  <el-header>
    <main-header />
    <calendar class="restaurant-calendar"></calendar>
  </el-header>
  <el-container class="restau-container" :class='{ "restau-container-mod-switch": getModSwitchTable }'>
    <div class="restau-mod-switch" :class='{ "restau-mod-switch_on": getModSwitchTable }'>
      <span style="margin-right:15px">Changer Table</span>
      <el-button class="red" @click="abordSwitchMod()">Annuler</el-button>
      <el-button class="green" v-if="getSwitchTableCanBeValidated" @click="validSwitchMod()">Valider</el-button>
    </div>
    <el-aside class="pan-left" width="415px">
      <multi-room-stat class="pan-left-stat-mob" />
      <main-left-side />
    </el-aside>
    <el-main class="pan-right">
      <main-right-side />
    </el-main>
    <transition name="fade">
      <popup-manage-resa v-if="isVisiblePopupManageServices" />
    </transition>
    <transition name="fade">
      <popup-table-selected v-if="isVisiblePopupTableSelected && !getModSwitchTable" />
    </transition>
  </el-container>
  <transition name="fade">
    <services v-if="isVisibleScreenServices" />
    <events v-if="isVisibleScreenEvents" />
    <discount v-if="isVisibleScreenDiscount" />
    <LockedServicesList v-if="isVisibleScreenLockedServices" />
    <LockedRoomsList v-if="isVisibleScreenLockedRooms" />
    <integration v-if="isVisibleScreenIntegration" />
    <infos v-if="isVisibleScreenInfos" />
    <reviews v-if="isVisibleScreenReviews" />
    <ClientsBook v-if="isVisibleScreenClientBook" />
    <Stats v-if="isVisibleScreenStats" />
    <CashList v-if="isVisibleScreenCashList" />
    <ResaList v-if="isVisibleScreenResaList" />
  </transition>
  <el-dialog title="Informations client" top="9vh" :visible="isVisibleDialogEditClient" width="80%"
    :before-close="closeDialogEditClient">
    <client-edit :cid="getCidEditing"></client-edit>
  </el-dialog>
  <el-dialog title="Annulation de la réservation" top="9vh" :visible="isVisibleDialogCancelResa" width="80%"
    :before-close="closeDialogCancelResa">
    <resa-cancelling></resa-cancelling>
  </el-dialog>
  <el-dialog title="Edition caution / prépaiement" top="9vh" :visible="isVisibleDialogEditCash" width="80%"
    :before-close="closeDialogEditCash">
    <cash-edit></cash-edit>
  </el-dialog>
  <el-dialog title="Edition d'évènements" top="9vh" ref="dialogEvent" :visible="isVisibleDialogEditEvent" width="80%"
    :before-close="closeDialogEditEvent">
    <event-edit></event-edit>
  </el-dialog>
  <el-dialog title="Edition des réductions" top="9vh" ref="dialogDiscount" :visible="isVisibleDialogEditDiscount"
    width="80%" :before-close="closeDialogEditDiscount">
    <discount-edit></discount-edit>
  </el-dialog>
  <el-dialog title="Erreur" :visible.sync="isVisibleDialogError" width="30%" :before-close="closeDialogError">
    <span>Les informations renseignées ne sont pas correctes</span>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="closeDialogError()">OK</el-button>
    </span>
  </el-dialog>
  <el-dialog title="Vous allez valider un paiement" :visible.sync="isVisibleDialogPayement" width="50%"
    :before-close="closeDialogPayement">
    <resa-payement></resa-payement>
  </el-dialog>
  <div :class="['pointWS', { 'pointWS-isAlive': socketIsAlive }]"></div>
</el-container>
